import StepBase from '../stepform/StepBase';
import MediaService from '../../services-js/media.service';

class EvalWelcome extends StepBase {
    questionCols = [];
    handleResizeTimer = null;
    imageUrl = null;

    async beforeMount() {
        if (this.props.route && this.props.route.other) {
            const {slots, product} = this.props.route.other;
        
            if (product) {
                const { imageId } = product;
                if (imageId) {
                    const image = await MediaService.getImage(imageId);
                    this.imageUrl = await MediaService.crop({image, alias: '5:3'});
                }
            }

            this.slots = slots || this.slots;
        }
    }

    mounted() {
        this.querySelector('[ref="next"]').addEventListener('click', async (e) => {
            this.props.navhandler(this.props.index + 1)
        })
    }

    template() {
        return `
            <article class="fu-eval__group primary__bg secondary__text secondary__headlines secondary__content tertiary__links" grid="wrap">
                <header class="flexy direction--column justify--center" column="s-12 l-6">
                    ${this.slots.welcomeMessage ? this.slots.welcomeMessage.innerHTML : ''}
                </header>
                <main class="fu-eval__submit-main" column="s-12 l-5 l+1">
                    ${this.imageUrl ? `
                        <img class="fu-eval__submit-img" src="${this.imageUrl}" />
                        <span class="patch top primary__text"></span><span class="patch bottom primary__text"></span>
                    ` : ''}
                </main>
                <footer class="fu-eval__group-footer" column="s-12">
                    <button class="fu-eval__group-btn fu-button tertiary__bg quaternary__text" type="button" ref="next">
                        Næste
                    </button>
                </footer>
            </article>
        `;
    }
  }
  
  // register component
  customElements.define( 'eval-welcome', EvalWelcome );
